
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  subnav: true,
  maxTocLevel: 4,
  layout: 'reference',
  secondLevelToc: true,
  alwaysExpand: true,
  parentTocLevel: 3,
  childTocLevel: 4,
  description: 'API reference for endpoints and webhooks associated with the Plaid Investments Move product.',
  source: 'endpoint'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Investments Move' subtitle='API reference for Investments Move endpoints and webhooks' compact mdxType="Header" />
    <p>{`For how-to guidance, see the `}<a parentName="p" {...{
        "href": "/docs/investments-move/"
      }}>{`Investments Move documentation`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Endpoints`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/investments/auth/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch investments data required for ACATS or ATON transfer`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`See also`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/investments/auth/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch Investments Auth data`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "investmentsauthget"
    }}>{`/investments/auth/get`}</h4>
    <Schema method='POST' route='/investments/auth/get' type='request' mdxType="Schema">
      <MDXCodeBlock title='/investments/auth/get' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/investments/auth/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "access_token": String
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: InvestmentsAuthGetRequest = {
  access_token: accessToken,
};
try {
  const response = await plaidClient.investmentsAuthGet(request);
  const investmentsAuthData = response.data;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = InvestmentsAuthGetRequest(access_token=access_token)
response = client.investments_auth_get(request)
investmentsAuthData = response
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`InvestmentsAuthGetRequest request = new InvestmentsAuthGetRequest()
  .accessToken(accessToken);
Response<InvestmentsAuthGetResponse> response = client()
  .investmentsAuthGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::InvestmentsAuthGetRequest.new({ access_token: access_token })
response = client.investments_auth_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewInvestmentsAuthGetRequest(accessToken)
resp, _, err := client.PlaidApi.InvestmentsAuthGet(ctx).InvestmentsAuthGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.InvestmentsAuthGetRequest{AccessToken: accessToken}
resp, err := client.Investments.GetAuth(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/investments/auth/get' type='response' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "investmentsauthget",
        level: 4,
        title: "/investments/auth/get",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
